export const TOPIC_LABELS = {
  battleBreakdown: 'Battle Breakdown',
  weekRecap: 'Week Recap',
};

export function getTopicLabel(topicId) {
  return TOPIC_LABELS[topicId] || topicId;
}

export function isKnownTopic(topicId) {
  return Object.prototype.hasOwnProperty.call(TOPIC_LABELS, topicId);
}
